import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Settings as SettingsIcon, Info } from 'lucide-react';

export default function Settings() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <div className="p-6 md:p-10">
        <div className="text-center py-12">
          <SettingsIcon className="w-12 h-12 text-[#8D99AE] mx-auto mb-4" />
          <h3 className="text-lg font-medium text-[#2B2D42]">Acceso restringido</h3>
          <p className="text-[#5D5C61] mt-1">
            Solo los administradores pueden acceder a la configuración
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 md:p-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#2B2D42] font-['Manrope']">Configuración</h1>
        <p className="text-[#5D5C61] mt-1">Parámetros del sistema</p>
      </div>

      <div className="max-w-2xl space-y-6">
        <Card className="border-slate-100">
          <CardHeader>
            <CardTitle className="text-xl font-['Manrope'] flex items-center gap-2">
              <Info className="w-5 h-5 text-[#335C67]" />
              Información general
            </CardTitle>
            <CardDescription>
              Las opciones de duración de citas, intervalos SOAP y recordatorios han sido
              desactivadas. El horario de agendamiento (lunes a sábado) y el paso entre slots se
              configuran en el servidor con las variables de entorno{' '}
              <code className="text-xs bg-slate-100 px-1 rounded">BOOKING_SCHEDULE_START</code>,{' '}
              <code className="text-xs bg-slate-100 px-1 rounded">BOOKING_SCHEDULE_END</code> y{' '}
              <code className="text-xs bg-slate-100 px-1 rounded">BOOKING_SLOT_STEP_MINUTES</code>{' '}
              (por defecto 12:00–20:00 cada 15 min). Para citas fuera de ese rango use &quot;Forzar
              Cita&quot; al agendar.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3 text-sm text-[#5D5C61]">
            <p>
              Notas de seguimiento: la numeración es por cliente dentro de cada registro.
              Asistencia y pago: se gestionan desde el detalle de cada cita.
            </p>
            <p>
              El <strong>monto del pago</strong> se calcula automáticamente como la suma de los
              precios de los servicios asignados a la cita (configúralos en la página{' '}
              <strong>Servicios</strong>).
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
